export default __webpack_public_path__ + "static/loan-place-1e79f3623d69e37d76f79deb98e5e55f.png";